import privateInstance from "../privateClient";
import {
  CalculateDrayageQuoteQueryType,
  CalculateTollsQueryType,
  FetchDrayageSearchShippingLocationsQueryType,
  FetchFuelSurchargeProfilesQueryType,
  FetchOperationalExpensesProfilesQueryType,
  FetchTariffPricingTiersQueryType,
  SetOfferPriceQueryType,
} from "./types";

export const drayageApi = {
  getTariffPricingTiersLimited: async (
    params: FetchTariffPricingTiersQueryType["Params"],
  ) => {
    try {
      const response = await privateInstance.post<
        FetchTariffPricingTiersQueryType["Data"]
      >("/drayage/list-tariff-pricing-tiers-new", params);

      return response.data;
    } catch (err) {
      return null;
    }
  },

  getFuelSurchargeProfiles: async (
    params: FetchFuelSurchargeProfilesQueryType["Params"],
  ) => {
    try {
      const response = await privateInstance.post<
        FetchFuelSurchargeProfilesQueryType["Data"]
      >("/drayage/list-fuel-surcharge-profiles", params);

      return response.data;
    } catch (err) {
      return null;
    }
  },

  getOperationalExpensesProfiles: async (
    params: FetchOperationalExpensesProfilesQueryType["Params"],
  ) => {
    try {
      const response = await privateInstance.post<
        FetchOperationalExpensesProfilesQueryType["Data"]
      >("/drayage/list-operational-expenses-profiles", params);

      return response.data;
    } catch (err) {
      return null;
    }
  },

  getDrayageSearchShippingLocations: async (
    params: FetchDrayageSearchShippingLocationsQueryType["Params"],
  ) => {
    try {
      const response = await privateInstance.post<
        FetchDrayageSearchShippingLocationsQueryType["Data"]
      >("/drayage/list-drayage-search-locations", params);

      return response.data;
    } catch (err) {
      return null;
    }
  },

  calculateDrayageQuote: async (
    params: CalculateDrayageQuoteQueryType["Params"],
  ) => {
    try {
      const response = await privateInstance.post<
        CalculateDrayageQuoteQueryType["Data"]
      >("/drayage/calculate-quote", params);

      return response.data;
    } catch (err) {
      return null;
    }
  },

  calculateRouteTolls: async (params: CalculateTollsQueryType["Params"]) => {
    try {
      const response = await privateInstance.post<
        CalculateTollsQueryType["Data"]
      >("/drayage/calculate-tolls-using-geo-coordinates", params);

      return response.data;
    } catch (err) {
      return null;
    }
  },

  setOfferPrice: async (params: SetOfferPriceQueryType["Params"]) => {
    try {
      const response = await privateInstance.post<
        SetOfferPriceQueryType["Data"]
      >("/drayage/set-offered-price", params);

      return response.data;
    } catch (err) {
      return null;
    }
  },
};
